import React from "react";
import ReportPage from "./ReportPage";

export default function UnionReports() {
  return (
    <ReportPage
      title="Union Reports"
      subtitle="Union deduction schedule."
      endpoint="/reports/statutory/union"
      exportName="union"
      summaryCards={[
        { key: "total_amount", label: "Total Amount", money: true },
        { key: "staff_count_on_page", label: "Staff Count" },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "item", label: "Item" },
        { key: "amount", label: "Amount" },
      ]}
    />
  );
}
